module.exports = __webpack_public_path__ + "img/car6.5eea051e.png";